<div class="background">
    <app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
    <div class="card">
        <div class="card-content">
            <div class="header">
                <img src="assets/images/temporary-logo.png" alt="System Logo" class="logo" />
                <h1>ROADTAX</h1>
            </div>
            <div class="form-container">
                <div class="mt-1" *ngIf="isError" style="color: red; text-align: center">{{loginErrorMessage}}</div>
                <form [formGroup]="signInForm">
                    <label>Email</label>
                    <app-text-field [control]="$any(signInForm.get('email'))" [submitted]="submittedSignInForm"
                        [placeholder]="'Email'" [errorMessage]="'Email are required'"></app-text-field>
                    <label>Password</label>
                    <app-text-field [control]="$any(signInForm.get('password'))" [submitted]="submittedSignInForm"
                        [type]="passwordVisible ? 'text' : 'password'" [placeholder]="'Password'"
                        [errorMessage]="'Password are required'"></app-text-field>
                    <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
                        <i [class]="passwordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                    </button>
                    <button type="submit" class="action-btn" (click)="onSignIn()">SIGN IN</button>
                </form>
            </div>
        </div>
    </div>
</div>
<app-spinner [state]="progressState"></app-spinner>